const GENRE_DURATIONS = [
  7, 15, 30, 45, 60, 75, 90, 105, 120, 135, 150, 165, 180
]
export const getClosestGenreDuration = (duration: number) => {
  const desiredDuration = parseInt(String(duration))

  switch (true) {
    case desiredDuration > GENRE_DURATIONS[GENRE_DURATIONS.length - 1]:
      return GENRE_DURATIONS[GENRE_DURATIONS.length - 1]
    case desiredDuration < 13:
      return GENRE_DURATIONS[0]
    case desiredDuration < 21:
      return GENRE_DURATIONS[1]
    default:
      return GENRE_DURATIONS.find(duration => desiredDuration <= duration)
  }
}
